const ENTER_KEY = "Enter";
const COMBOBOX_SELECTION_KEYS = [" ", ENTER_KEY];
//#endregion
export { COMBOBOX_SELECTION_KEYS, ENTER_KEY };
